export const container = `
  w-full flex gap-2 items-center justify-between mb-3
`;
export const title = `flex grow gap-2 items-center`;
export const text = `text-nowrap text-gray-800 font-bold flex items-center -mt-1`;
